import React from "react";
import "./footer.css";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <div className="footer-content">
        <div className="footer-social">
          <a href="https://github.com/Vincent-SS" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
            <GitHubIcon />
          </a>
          <a href="https://www.linkedin.com/in/w-vincent-shi/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <LinkedInIcon />
          </a>
          <a href="mailto:vincentshiwork@gmail.com" aria-label="Email">
            <EmailIcon />
          </a>
        </div>
        <div className="footer-text">
          <p>© {currentYear} Vincent Shi</p>
          <p className="footer-tagline">Built with passion & caffeine ☕</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
